




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ArticlePreview from '@/components/article/ArticlePreview.vue';
import { Article, ArticleQueryParam } from '@/services/articles';
import articles from '../../store/articles';

@Component({
  components: {
    ArticlePreview
  }
})
export default class ArticleList extends Vue {
  @Prop() type!: string;
  currentPage = 1;
  itemsPerPage = 5;

  get listQueryParam(): ArticleQueryParam {
    const filters: ArticleQueryParam = {
      offset: (this.currentPage - 1) * this.itemsPerPage,
      limit: this.itemsPerPage
    };

    return filters;
  }

  fetchArticles() {
    this.$store.dispatch('home/fetchArticles', this.listQueryParam);
  }

  mounted() {
    this.fetchArticles();
  }

  @Watch('currentPage')
  currentPageChange() {
    this.fetchArticles();
  }

  get articles(): Article[] {
    return this.$store.getters['home/getArticles'];
  }

  get pageCount() {
    const articlesCount = this.$store.getters['home/articlesCount'];
    return articlesCount / this.itemsPerPage;
  }

  get isLoading(): boolean {
    return this.$store.getters['home/isLoading'];
  }
}
